import React, { useRef, useState } from "react";
import styles from "./shape-menu-icon.module.css";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { useSetAtom } from "jotai";
import { isDraggingElementAtom } from "state-atoms";
import { useIsCIMReorderEnabled } from "utils/url-utils";

function ShapeMenuIcon({
  shapeId,
  displayName,
  thumbnail,
  onClick,
  onMouseDown,
  selected = false,
  size = 24,
  padding = 6,
  testid,
}: {
  shapeId: string;
  displayName?: string;
  onClick?: () => void;
  onMouseDown?: () => void;
  thumbnail: string | React.ReactNode;
  selected?: boolean;
  size?: number;
  padding?: number;
  testid?: string;
}) {
  const setIsDraggingElement = useSetAtom(isDraggingElementAtom);
  const [error, setError] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const hover = useHover(ref);
  const isCimReorderEnabled = useIsCIMReorderEnabled();
  const { width, height } = { width: size, height: size };

  return (
    <div
      ref={ref}
      className={styles.icon}
      style={{
        padding,
        backgroundColor: selected ? "#E6F1FF" : undefined,
        border: "1px solid",
        borderColor: selected ? "#A4CCFF" : "transparent",
        cursor: onMouseDown ? "grab" : "pointer",
      }}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onDragStart={(e) => {
        e.preventDefault();
        setIsDraggingElement(true);
      }}
      draggable={!!onMouseDown}
      data-testid={testid || `shape-menu-icon-${shapeId}`}
    >
      <div className={styles.iconContent} style={{ width, height }}>
        {error && <div className={styles.skeleton} style={{ width, height }} />}
        {!error &&
          (typeof thumbnail === "string" ? (
            <img
              src={`data:image/svg+xml,${encodeURIComponent(thumbnail)}`}
              alt={shapeId}
              onError={() => setError(true)}
            />
          ) : (
            thumbnail
          ))}
      </div>

      {hover && displayName && (
        <Tooltip
          side="top"
          label={displayName}
          relativeTo={ref}
          boundary="none"
          design={isCimReorderEnabled ? "monday" : "default"}
        />
      )}
    </div>
  );
}

export default ShapeMenuIcon;
